export default __webpack_public_path__ + "static/media/arrow-right.bfb7ece8.svg";